import { Action } from 'api/types';

export type CreateFetchInstitutionData = (eventId: string) => Action;
export type GetLinkedinInAccessCode = (code: string) => Action;
export type GetLinkedinInAccessToken = (body: LinkedinAccessTokenRequestBody) => Action;
export type CreateFetchSelfClipData = (eventId: string) => Action;
export type CreateFetchInstitutionEventData = (domain: string, partOfInstitutionId: string) => Action;
export type SendEmailForSubscripe = (participantId: string) => Action;
export type GetLinkedInAccessToken = (code: string) => Action;
export type CreateFetchSubscriberData = (participantId: string) => Action;

export type CreateParticipantBody = {
  firstName: string;
  lastName: string;
  email: string;
  subtitle?: string;
  isAllowForMarketing: boolean;
  registerWithLinkedIn?: boolean;
};

export type CreateEmailCheckBody = {
  email: string;
};

export type SendEmailForSubscripeBody = {};

export type CreateFetchParticipantData = (eventId: string) => (body: CreateParticipantBody) => Action;
export type CreateEmailCheckEvent = (eventId: string) => (body: CreateEmailCheckBody) => Action;

export enum ClipPurchaseTypes {
  None = 'None',
  WholesaleClientPays = 'WholesaleClientPays',
  WholesaleBDRClientPays = 'WholesaleBDRClientPays',
  RetailEndUserPays = 'RetailEndUserPays',
  PartnerNetworkHerffJones = 'PartnerNetworkHerffJones',
  PartnerNetworkLifeTouch = 'PartnerNetworkLifeTouch',
  PartnerNetworkReedGraduations = 'PartnerNetworkReedGraduations',
  UnknownAtThisTime = 'UnknownAtThisTime',
  PartnerNetworkFSM = 'PartnerNetworkFSM',
  PartnerNetworkTempest = 'PartnerNetworkTempest',
}

export type InstitutionDataResponse = {
  institutionId: string;
  name: string;
  startDateOnly: Date;
  startTimeOnly: any;
  institutionName: string;
  institutionLogo: string;
  isAllowCollctiv: boolean;
  clipPurchaseType: ClipPurchaseTypes;
  isAllowForAmazonMusic: boolean;
};

type event = {
  eventId: string;
  name: string;
  clipPurchaseType: ClipPurchaseTypes;
};

export type InstitutionEventDataResponse = {
  institutionName: string;
  institutionLogo: string;
  isAllowCollctiv: boolean;
  isAllowForAmazonMusic: boolean;
  id: string;
  events: event[];
};
export type SelfClippingDataResponse = {
  eventId: string;
  isSelfClipping: boolean;
  isFromSelfOnBoard: boolean;
};

export type LinkedinAccessTokenRequestBody = {
  code: string;
  email: string;
  eventId: string;
  subtitle?: string;
};

export type ConfirmCollectiveUiForParticipantBody = {
  allowDonation: string;
};

export type ConfirmParticipantCollectiveData = (
  participantId: string,
) => (body: ConfirmCollectiveUiForParticipantBody) => Action;

export type PostSubscriberData = (participantId: string) => (body: any) => Action;
